import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Publications from "@/pages/Publications";
import Tools from "@/pages/Tools";
import Seminars from "@/pages/Seminars";
import Blog from "@/pages/Blog";
import ArticleView from "@/pages/ArticleView";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-cream text-ink font-body grain" data-testid="app-root">
          <a
            href="#main-content"
            data-testid="skip-to-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[80] focus:bg-ink focus:text-cream focus:px-5 focus:py-2.5 focus:rounded-full focus:text-sm focus:font-medium"
          >
            Μετάβαση στο περιεχόμενο
          </a>
          <Header />
          <main id="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ekdoseis" element={<Publications />} />
              <Route path="/ergaleia" element={<Tools />} />
              <Route path="/seminaria" element={<Seminars />} />
              <Route path="/arthra" element={<Blog />} />
              <Route path="/arthra/:id" element={<ArticleView />} />
              <Route path="/gia-emas" element={<About />} />
              <Route path="/epikoinonia" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
